// extracted by mini-css-extract-plugin
export default {"argCont":"ArgumentSetup_argCont__86OJJ","argInput":"ArgumentSetup_argInput__v7cGT"};